module.exports = __webpack_public_path__ + "img/0527-n.7923c79e.svg";